import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-delete-confirm',
    templateUrl: './delete-confirm.component.html',
    styleUrls: ['./delete-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteConfirmComponent {

  @Input() public title = 'Confirmation de suppression';
  @Input() public message = 'Confirmez-vous la suppression ?';

  @Output() public deleted = new EventEmitter();
  @Output() public dismissed = new EventEmitter();
  @Output() public opened = new EventEmitter();

  @ViewChild('deleteConfirmationModal') deleteConfirmationModalTemplate: TemplateRef<any>;

  private modal: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  delete() {
    this.deleted.emit();
    this.closeModal();
  }

  dismiss() {
    this.dismissed.emit();
    this.closeModal();
  }

  @HostListener('click')
  openModal() {
    this.modal = this.modalService.open(this.deleteConfirmationModalTemplate);
    this.opened.emit();
  }

  closeModal() {
    this.modal.close();
  }
}
